import { IconSize } from '@/components/Atoms/Icon/Icon';
import styled, { css } from 'styled-components';

const baseIconStyle = (icon: string, dim: string = IconSize.SMALL) => css`
    content: '';
    display: inline-block;
    width: ${dim};
    height: ${dim};
    background: url(${icon}) no-repeat;
    filter: var(--color-LinkAwareContainer-icon);
    @media print {
        display: none;
    }
`;
/**
 * This component decorates all terminal links within it by adding a terminal icon.
 */
export const LinkAwareContainer = styled.div`
    em,
    li,
    span,
    td,
    p {
        > a[href^='http'] {
            display: inline-block;
            &:after {
                ${baseIconStyle('/_static/icons/expand.svg', IconSize.EXTRA_SMALL)};
                vertical-align: baseline;
                margin: 0 2px;
            }
        }

        > a[href^='mailto'] {
            display: inline-block;
            &:after {
                ${baseIconStyle('/_static/icons/mail.svg', IconSize.EXTRA_SMALL)};
                vertical-align: baseline;
                margin: 0;
            }
        }

        > a[href^='bbg://'],
        > a[href^='https://blinks.bloomberg.com/'],
        > a[href^='https://bloom.bg/'] {
            display: inline-block;
            &:after {
                ${baseIconStyle('/_static/icons/terminal.svg')};
                vertical-align: text-bottom;
                margin: 0;
            }
        }
    }
`;
